module.exports = __webpack_public_path__ + "img/alipay.4e49ab9f.png";